<template>
    <div class="wechat-key-wrap">
        <div class="header-return">

            <el-row :gutter="20">
                <el-col :span="2">
                    <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
                </el-col>
                <el-col :span="3" offset="19">
                    <el-tooltip class="item" effect="dark" content="文案里配多个连接参考关键字 关键字多连接参考 " placement="right">
                        <el-button type="success" size="mini" @click="getDemoImg">多个连接参考示例</el-button>
                    </el-tooltip>
                </el-col>
            </el-row>
        </div>

        <el-form :model="form" label-width="80px">
            <el-form-item label="id" :hidden="true">
                <el-input v-model=form.id></el-input>
            </el-form-item>
            <el-form-item label="类型" :required="true">
                <el-select v-model="form.type" filterable clearable placeholder="类型" @change="keywordTypeChange">
                    <el-option v-for="item in keywordTypeData"
                               :key="item.id"
                               :label="item.name"
                               :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="平台" v-show="form.type=='news'||form.type=='image'">
                <el-select v-model="form.platformId" placeholder="平台"   :disabled="platformDisabled">
                    <el-option v-for="item in platformData"
                               :key="item.platformId"
                               :label="item.platformName"
                               :value="item.platformId">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="关键字" :required="true">
                <el-input v-model=form.keyword clearable placeholder="关键字"></el-input>
            </el-form-item>

            <template v-if="type=='text'||type=='miniCard'">
                <el-form-item label="标题" :required="true">
                    <el-input type="textarea"
                              :rows="5" v-model=form.title clearable placeholder="标题 长度不要超过1000个字符"></el-input>
                </el-form-item>
                <el-form-item v-if="type=='text'" label="摘要" >
                    <el-input type="textarea"
                              :rows="5" v-model=form.content clearable placeholder="摘要 长度不要超过1000个字符"></el-input>
                </el-form-item>
                <el-form-item label="URL">
                    <el-input v-model="form.url" clearable placeholder=" h5跳转连接  如类型是卡片请填写小程序路径 "></el-input>
                </el-form-item>
            </template>


            <el-form-item label="素材" v-if="type=='news'" :required="true" @focus="">
                <el-select v-model="form.mediaId"  filterable clearable placeholder="素材" style="width: 100%;">
                    <el-option style="max-width: 100%" v-for="item in mediaData"
                               :key="item.mediaId"
                               :label="item.title"
                               :value="item.mediaId">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="图片" v-if="type=='image'||type=='miniCard'">
                <el-button @click="selectUpload" size="mini">上传图片</el-button>
                <el-image
                        class="select-pic"
                        style="width: 100px; max-height: 200px;display:block;margin-top: 10px"
                        :src="form.imageUrl"
                        :preview-src-list="[form.imageUrl]">
                </el-image>
            </el-form-item>
            <el-form-item label="父关键字" prop="keywordId">
                <el-select v-model="form.parentId" clearable filterable placeholder="请选择关键字">
                    <el-option
                        v-for="item in keywordList"
                        :key="item.id"
                        :label="item.keyword"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" size="mini" @click="save(form)">确 定</el-button>
            </el-form-item>
        </el-form>
        <picDialog :picType="''" :fromState="'onlyOne'" @selectPicOne="selectPicOne"></picDialog>
        <el-dialog title="多连接参考示例" :visible.sync="dialogFormVisible" center>
            <el-form>
                <el-form-item>
                    <img :src="imgDemoUrl"/>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="mini" @click="closeDemo">关闭</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {saveKeywords, getKeywordsDetail, getPlatformList2, getMiniCardList, getKeywordsOption,getMediaListOption} from '../../api/api';
    import picDialog from '@/components/pic_dialog/pic_list'

    //定义组件
    export default{
        data(){
            return {
                id: this.$route.params.id,
                type: this.$route.query.type,
                listData: [],
                platformData: [],
                keywordTypeData: [{"id": "text", "name": "文本"}, {"id": "news", "name": "图文"}, {
                    "id": "image",
                    "name": "图片"
                }, {"id": "coupon", "name": "优惠券"}, {"id": "miniCard", "name": "小程序卡片"}],
                mediaData: [],
                cardData: [],
                keywordList: [],//关键字列表
                loading: true,
                imgDemoUrl: 'https://resource1.lechun.cc/1000/sysImg/keyworldWithManyUrl.png',
                dialogFormVisible: false,
                form: {
                    "id": 0,
                    "platformId": 1,
                    "keyword": "",
                    "type": "text",
                    "title": "",
                    "content": "",
                    "mediaId": "",
                    "url": "",
                    "imageUrl": ""
                },
                formInline: {
                    platformId: 0,
                    currentPage: 1,
                    pageSize: 15,
                    recordsTotal: 0,
                },
                selectImageUrl: '',
                platformDisabled: false,
            }
        },
        //挂载时候执行
        mounted(){
            if (this.id != 0) {
                this.initDetail();
            }
            getPlatformList2(this.formInline).then((res) => {
                this.platformData = res.data;
                this.formInline.platformId = res.data[0].platformId;
                //初始化首页数据
                getMediaListOption(this.formInline).then((res) => {
                    this.platformData = res.data;
                    this.mediaData = res.data.value;
                    //初始化首页数据
                });
            });
            this.getEnableKeyworldList();
        },
        components: {
            picDialog
        },

        methods: {
            initDetail(){
                getKeywordsDetail({keyWordId: this.id}).then((res) => {
                    console.log('de', res)
                    this.form = res.data.value;
                    this.keywordTypeChange(this.form.type);
                });
            },
            //定义查询方法
            keywordTypeChange(data){
                this.type = data
            },
            selectPicOne(obj){
                console.log(obj)
                this.$store.commit('SET_PIC_DIALOG', false)

                this.form.imageUrl = obj.allImagePath
                this.selectImageUrl = obj.allImagePath

            },
            selectUpload(){
                this.$store.commit('SET_PIC_DIALOG', true)
            },
            getEnableKeyworldList(){
                //关键字
                getKeywordsOption({platformId: 1}).then((res) => {
                    this.keywordList = res.data.filter(item => (item.type == 'text'|| item.type == 'image' || item.type == 'coupon' || item.type == 'news'|| item.type == 'miniCard'));
                    this.keywordList.push({'id': 0, 'keyword': '无'});
                });
            },
            save(data){
                console.log(data);
                if (data.keyword == "") {
                    this.$message({
                        message: "请输入关键字",
                        type: 'error'
                    });
                    return;
                }
                if (data.type == "") {
                    this.$message({
                        message: "请选择关键字类型",
                        type: 'error'
                    });
                    return;
                }
                if (data.type == "image" && data.imageUrl == "") {
                    this.$message({
                        message: "请选择图片",
                        type: 'error'
                    });
                    return;
                }
                if (data.type == "news" && data.mediaId == "") {
                    this.$message({
                        message: "请选择素材",
                        type: 'error'
                    });
                    return;
                }
                saveKeywords(data).then((res) => {
                    if (res.data.success) {
                        this.$message({
                            message: res.data.message,
                            type: 'success'
                        });
                        window.history.back()
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },

            keywordType(row, column, cellValue) {
                for (var key in this.keywordTypeData) {
                    if (this.keywordTypeData[key].id == cellValue) {
                        return this.keywordTypeData[key].name;
                    }
                }
            },
            titleProccess(row, column, cellValue) {
                if (row.type == "news") {
                    return row.mediaTitle;
                } else {
                    return cellValue;
                }
            },
            getDemoImg(){
                this.dialogFormVisible = true;
            },
            closeDemo(){
                this.dialogFormVisible = false;
            },
            returnHistory(){
                window.history.back()
            }
        }
    }

</script>
<style lang="scss" rel="stylesheet/scss" scoped>
    .wechat-key-wrap {
        padding: 10px;
        .header-return {
            margin-bottom: 20px;
            border-bottom: 1px solid #eeeeee;
            padding-bottom: 10px;
            position: relative;
            h2 {
                text-align: center;
                position: absolute;
                left: 50%;
                top: 0;
                margin: 0;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/wechat/wechatKeywordDetail.vue